<template>
  <div class="employee-apartment-documents-panel">
    <vx-card :title="`Документы ${type === 'apartment' ? 'помещения' : 'дома'}`">
      <span slot="actions">
        <vs-button
          type="border" size="medium" @click="openAddFilePopup"
          class="vs-button_square"
        >
          Прикрепить
        </vs-button>
      </span>
      <div>
        <vs-table :data="documents" no-data-text="Документов нет">
          <template slot="thead">
            <vs-th>Дата добавления</vs-th>
            <vs-th>Файл</vs-th>
            <vs-th>Виден для пользователя</vs-th>
            <vs-th />
          </template>

          <template slot-scope="{data}" ref="content">
            <vs-tr :key="indextr" v-for="(tr, indextr) in data">
              <vs-td>
                <div class="flex items-center">
                  {{ tr.created_at | moment('DD.MM.YYYY HH:mm:ss') }}
                </div>
              </vs-td>
              <vs-td>
                <div>
                  <a :href="tr.file.path | imgPath" target="_blank" :download="tr.file.name">{{ tr.file.name }}</a>
                </div>
              </vs-td>
              <vs-td>
                <vs-tooltip :text="tr.not_editable" :active="!!tr.not_editable">
                  <div class="flex">
                    <div style="width: 50px;">{{ tr.visible_by_owner ? 'Да' : 'Нет' }}</div>
                    <vs-switch
                      :disabled="tr.not_editable"
                      size="small"
                      :value="tr.visible_by_owner"
                      @input="onToggleVisible($event, tr)"
                    />
                  </div>
                </vs-tooltip>
              </vs-td>
              <vs-td>
                <vs-tooltip :text="tr.not_deletable" :active="!!tr.not_deletable">
                  <vs-button
                    color="primary"
                    type="border"
                    :disabled="tr.not_deletable"
                    @click="askForDeleteDocument(tr.id)"
                    iconPack="feather"
                    icon="icon-trash"
                    title="Удалить"
                  />
                </vs-tooltip>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
    </vx-card>

    <AddDocumentPopup
      ref="AddDocumentPopup"
      :appartmentId="apartInfo.id"
      :buildingsId="buildingsId"
      :type="type"
      @updated="getDocuments"
    />
  </div>
</template>

<script>
import AddDocumentPopup from "@/components/calculated-program/account/AddDocumentPopup";
import notifyHttpError  from "@/mixins/notifyHttpError";

export default {
  name:       "DocumentsPanel",
  mixins:     [notifyHttpError],
  components: {
    AddDocumentPopup,
  },
  props:      {
    accountNumber: {},
    buildingsId:   {},
    apartInfo:     {
      default() {return {};},
    },
    type:          String,
  },
  data() {
    return {
      documents: [],
    };
  },
  methods: {
    openAddFilePopup() {
      this.$refs.AddDocumentPopup.open();
    },
    async getDocuments() {
      let url = this.type === 'apartment' ? `documents/get_apartment/${this.accountNumber}` : 'documents/get_building';

      let { data: documents } = await this.$http.get(url, {
        params: {
          buildings_id: this.buildingsId,
        },
      });
      this.documents = documents;
    },
    askForDeleteDocument( id ) {
      this.$vs.dialog({
        type:       'confirm',
        color:      'danger',
        title:      'Подтверждение',
        text:       'Вы уверены что хотите удалить?',
        acceptText: 'Удалить',
        cancelText: 'Отменить',
        accept:     this.deleteFile,
        parameters: id,
      });
    },

    deleteFile( id ) {
      return this.$http.delete('/documents/remove', {
        params: {
          document_id:  id,
          buildings_id: this.buildingsId,
        },
      }).then(() => {
        this.$vs.notify({ color: "success", title: "Успешно", text: 'Файл удален' });
        this.getDocuments();
      }, this.notifyHttpError);
    },

    onToggleVisible( value, file ) {
      this.$http.put(`/documents/${file.id}`, {
        buildings_id:     file.file.buildings_id,
        visible_by_owner: value,
      }).then(this.getDocuments, this.notifyHttpError);
    },
  },
  mounted() {
    this.getDocuments();
  },
  watch: {
    buildingsId() {
      this.getDocuments();
    },
  },
};
</script>

<style lang="scss">

</style>
